import { FC } from 'react';

import { FadeAnimation, Page } from '@base-app';
import { StyledLogo } from './LoaderLogin.styles';

const LoaderLogin: FC = () => {
  return (
    <Page title="">
      <FadeAnimation>
        <StyledLogo data-testid={'loader-login-svg'} />
      </FadeAnimation>
    </Page>
  );
};

export default LoaderLogin;
